import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ComposeDraft } from '../pages/mail/components/mail-compose/mail-compose.component';
import { AdminService } from './admin.service';

export interface ResolvedEmailTemplateResult {
  template: any;
  billData: any;
  draft: ComposeDraft;
  tokenMap: Record<string, string>;
}

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateResolverService {
  constructor(private adminService: AdminService) {}

  resolveMonthlySalesMailDraft(pageId: number, billId: number) {
    return this.adminService.resolveMonthlySalesMailTemplate(pageId, billId).pipe(
      map((response: any) => {
        const data = response?.data || response || {};

        return {
          template: data.template || data.templatemaster || null,
          billData: data.billdata || data.billData || null,
          tokenMap: data.tokenmap || data.tokenMap || {},
          draft: {
            to: data.to || data.default_to || '',
            cc: data.cc || data.default_cc || '',
            bcc: data.bcc || data.default_bcc || '',
            subject: data.subject || '',
            body_html: data.body_html || data.bodyHtml || '',
            body_text: data.body_text || data.bodyText || '',
            openCcBcc: !!String(data.cc || data.default_cc || '').trim() || !!String(data.bcc || data.default_bcc || '').trim(),
            fromMailSource: data.from_mail_source || data.fromMailSource || 'gateway_account',
            fromMailExpression: data.from_mail_expression || data.fromMailExpression || '',
            fromEmail: data.from_email || data.fromEmail || data.resolved_from_email || data.resolvedFromEmail || '',
            fromMailPassword:
              data.from_mail_password
              || data.fromMailPassword
              || data.template?.from_mail_password
              || data.template?.frommailpassword
              || data.templatemaster?.from_mail_password
              || data.templatemaster?.frommailpassword
              || '',
            displayName:
              data.display_name
              || data.displayName
              || data.template?.display_name
              || data.template?.displayname
              || data.template?.template_name
              || data.template?.templatename
              || 'Template Mail',
            companyid: Number(data.companyid || data.template?.companyid || 0),
            userid: Number(data.userid || 0)
          } as ComposeDraft,
        } as ResolvedEmailTemplateResult;
      })
    );
  }

    resolvePurchaseOrderMailDraft(pageId: number, poId: number) {
    return this.adminService.resolvePurchaseOrderMailTemplate(pageId, poId).pipe(
      map((response: any) => {
        const data = response?.data || response || {};

        return {
          template: data.template || data.templatemaster || null,
          billData: data.billdata || data.billData || null,
          tokenMap: data.tokenmap || data.tokenMap || {},
          draft: {
            to: data.to || data.default_to || '',
            cc: data.cc || data.default_cc || '',
            bcc: data.bcc || data.default_bcc || '',
            subject: data.subject || '',
            body_html: data.body_html || data.bodyHtml || '',
            body_text: data.body_text || data.bodyText || '',
            openCcBcc: !!String(data.cc || data.default_cc || '').trim() || !!String(data.bcc || data.default_bcc || '').trim(),
            fromMailSource: data.from_mail_source || data.fromMailSource || 'gateway_account',
            fromMailExpression: data.from_mail_expression || data.fromMailExpression || '',
            fromEmail: data.from_email || data.fromEmail || data.resolved_from_email || data.resolvedFromEmail || '',
            fromMailPassword:
              data.from_mail_password
              || data.fromMailPassword
              || data.template?.from_mail_password
              || data.template?.frommailpassword
              || data.templatemaster?.from_mail_password
              || data.templatemaster?.frommailpassword
              || '',
            displayName:
              data.display_name
              || data.displayName
              || data.template?.display_name
              || data.template?.displayname
              || data.template?.template_name
              || data.template?.templatename
              || 'Template Mail',
            companyid: Number(data.companyid || data.template?.companyid || 0),
            userid: Number(data.userid || 0)
          } as ComposeDraft,
        } as ResolvedEmailTemplateResult;
      })
    );
  }
}
